import { ConfigProvider } from "antd";
import { ConfigProviderProps } from "antd/es/config-provider";
import useAntdLocale from "hooks/useAntdLocale";
import { customTheme as theme } from "theme/const";

const AntdProvider: React.FC<React.PropsWithChildren<ConfigProviderProps>> = (
  props
) => {
  const locale = useAntdLocale();

  return (
    <ConfigProvider
      {...{
        locale,
        theme,
        ...props,
      }}
    />
  );
};

export default AntdProvider;
